// extracted by mini-css-extract-plugin
module.exports = {"control":"DegradationVectorControl_control__3Rl0E","groupList":"DegradationVectorControl_groupList__2wKR_","removeButton":"DegradationVectorControl_removeButton__cu8yf"};